import type { Language } from "types/Language";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { PageType } from "utils/getProgramSelectorUrl";

interface QueryResponse {
  propertyId?: string; // This is the external id that is unique for the property which the parser gets
  guid?: string; // This is our internal id which is the primary key, unique for property
  campaignId?: string;
  language?: Language;
  userId?: string;
  legacyToken?: string;
  to?: string;
  domain?: string;
  pageType?: PageType;
  programInstanceId?: string;
  hqId?: string;
  isCustomerBranding?: boolean;
}

// We don't have array query params so override theirs
export interface AdfenixQuery<T = string> {
  [key: string]: T | undefined;
}
export const useQueryString = (): QueryResponse => {
  const { search } = useLocation();
  const query = queryString.parse(search) as AdfenixQuery;

  return {
    ...query,
    legacyToken: query.token,
    propertyId: query.id,
    guid: query.guid,
    isCustomerBranding: query["customer-branding"] === "true"
  };
};
